import type { ReactNode } from 'react';
import { cn } from '@/utils/cn';

export type SplitPageLayoutProps = {
  children: ReactNode;
  className?: string;
};

export const SplitPageLayout = ({
  children,
  className,
}: SplitPageLayoutProps) => {
  return (
    <div
      className={cn(
        'grid grid-cols-1 gap-5 lg:grid-cols-[1fr_22rem] xl:grid-cols-[1fr_28rem]',
        className
      )}
    >
      {children}
    </div>
  );
};
